import ConfirmationWithBackButton from 'src/components/Compliance/ConfirmationWithBackButton';
import MessageBox from 'src/components/Compliance/MessageBox';
import BadgeImg from '../../assets/images/FramedImage.png';
import Logomark from '../../assets/images/Logomark.png';

const CoverageVerified = () => {
  return (
    <ConfirmationWithBackButton
      title="Your coverage has been verified"
      subtitle="Your policy meets our landlord’s requirements. No further action is required at this time."
      image={BadgeImg}
      goBackLink="/compliance/welcome"
      message=
        <MessageBox
          image={Logomark}
          title="Still have question?"
        />
    />
  );
};

export default CoverageVerified;
